export default {
    cup: 'cup',
    oz: 'ounce',
    ml: 'milliliter'
};
